import { useMutation, UseMutationOptions } from 'react-query';

import Api from '../../api/api';

export type RequestOtpDto = {
  email?: string;
  phone?: string;
  isSignUp?: boolean;
};

export const requestOtp = async (params: RequestOtpDto): Promise<void> => {
  const [response, bodyOrError] = await Api.post('users/request-otp-code', params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useRequestOtp = (options?: Omit<UseMutationOptions<void, Error, RequestOtpDto, unknown>, 'mutationFn' | 'mutationKey'>) =>
  useMutation({
    ...options,
    mutationKey: ['requestOtp'],
    mutationFn: requestOtp,
  });
